/**
 * Labstep
 *
 * @module components/FilterPost/Report/ResourceLocation/Active/Post
 * @desc Active node component for ResourceLocation
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import { getPostFilterResourceLocation } from 'labstep-web/services/postFilter/filters/resourceLocation';
import type React from 'react';

export const FilterPostReportResourceLocationActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const filter = new PostFilter(
    [['guid', PostFilterComparison.eq]],
    'resourceItem.resourceLocation',
  );

  const filterWithName = new PostFilter(
    [
      ['name' as any, PostFilterComparison.eq],
      getPostFilterResourceLocation('resourceItem.resourceLocation'),
    ],
    'protocolValues',
  );

  if (
    !filterWithName.isNodeActive(node, undefined, true) &&
    !filter.isNodeActive(node)
  ) {
    return null;
  }

  const filterActive = filterWithName.isNodeActive(
    node,
    undefined,
    true,
  )
    ? filterWithName
    : filter;

  const { guid: guidAttribute } =
    filterActive.getAttributeValues(node);

  const guid = guidAttribute?.value;

  const attributes = filterActive.getAttributeValues(node);
  const protocolValueName = (attributes as any).name?.value;

  if (!guid) {
    return null;
  }

  return (
    <EntityReadEntityContainer
      entityName={ResourceLocation.entityName}
      id={guid}
    >
      {({ entity }): React.ReactElement | null =>
        entity ? (
          <RemoveLabel
            icon={ICONS.resource_location.primary}
            name={
              protocolValueName
                ? `${protocolValueName}: ${ResourceLocation.getHumanReadableEntityName(false, true)} is ${entity.name}`
                : `${ResourceLocation.getHumanReadableEntityName()} is ${entity.name} ${entity.name}`
            }
            onRemoveClick={onRemoveClick}
          />
        ) : null
      }
    </EntityReadEntityContainer>
  );
};
